module.exports = __webpack_public_path__ + "static/media/iitr.3ec6cde1.png";